export const FINANCE_CALCULATOR_MODAL_ID = 'finance-calc-modal';

export const BASE_URL_QA = 'https://finance-calculator-qa.kanda.co.uk/';

export const BASE_URL_PROD = 'https://finance-calculator.kanda.co.uk/';
